import { NavComponent, navTemplate } from './Nav';
export const navDefinition = {
    baseName: 'nav',
    template: navTemplate,
};
export const chameleonNav = NavComponent.compose(navDefinition);
